import { useState } from "react"

import { ReactComponent as ConnectEnvDataSvg } from "@/assets/icons/connect-env.svg"
import { Flex, Select, Text } from "@/atoms"
import * as AdrDomain from "@/domain/adr"
import {
  FILENAME_DATE_TIME_FORMAT,
  getDate,
  getDateInFormat
} from "@/helpers/date.helpers"
import { useTranslation } from "@/hooks/useTranslation"
import { CodeHighlight } from "@/molecules/CodeHighlight"
import { Description } from "@/pages/TriagePage/components/pages/AdrPage/components/Description"
import { AdrTabTemplate } from "@/pages/TriagePage/components/templates/AdrTabTemplate"

import styles from "./EvidenceTabAdr.module.scss"

import type { AdrIncident } from "@/domain/adr"

export const EvidenceTabAdr = (props: { incident: AdrIncident }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.adr.tabs.evidence"
  })
  const { incident } = props
  const { callStackEvidence } = incident.what
  const isMisMultipleCVE = AdrDomain.isMultipleCVE(incident)
  const vulnerabilities = AdrDomain.getVulnerabilities(incident)
  const codeCallStackEvidence = callStackEvidence?.join("\n")
  const [data, setData] = useState({
    index: 0,
    code:
      codeCallStackEvidence ||
      JSON.stringify(vulnerabilities[0]?.runtimeEvidence || "", null, 2) ||
      ""
  })
  const { code } = data
  const isRuntimeEvidence = !codeCallStackEvidence && !!data.code
  const filename = `kodem_evidence_${getDateInFormat(getDate(), FILENAME_DATE_TIME_FORMAT)}.${isRuntimeEvidence ? "json" : "txt"}`
  const title = isRuntimeEvidence ? "JSON" : "PLAIN TEXT"

  return (
    <AdrTabTemplate>
      <Description
        title={t(`title_${isRuntimeEvidence ? "runtime" : "callStack"}`)}
        gap={0}
      >
        <Flex vertical gap={16}>
          <Text type="secondary" className="sm-text-ks">
            {t(`description_${isRuntimeEvidence ? "json" : "txt"}`)}
          </Text>
          <Flex vertical gap={16}>
            {isMisMultipleCVE && (
              <Flex gap={10} align="center">
                <Text>{t("cveSelectLabel")}</Text>
                <Select
                  className={styles.select}
                  options={vulnerabilities.map(({ cve }, value) => ({
                    value,
                    label: cve
                  }))}
                  value={data.index}
                  onSelect={(value) => {
                    setData({
                      code: JSON.stringify(
                        vulnerabilities[value].runtimeEvidence || "",
                        null,
                        2
                      ),
                      index: value
                    })
                  }}
                />
              </Flex>
            )}
            {!code && (
              <Flex vertical gap={12} align="center">
                <ConnectEnvDataSvg />
                <Text className={styles.labelEmpty} type="secondary">
                  {t("noData")}
                </Text>
              </Flex>
            )}
            {!!code && (
              <CodeHighlight
                title={title}
                theme="dark"
                language="unknown"
                code={code}
                filename={filename}
              />
            )}
          </Flex>
        </Flex>
      </Description>
    </AdrTabTemplate>
  )
}
